(function () {
  'use strict';

  var API_BASE = 'https://dyefor-ai-studio.doimage.workers.dev';
  var SESSION_KEY = 'dyefor-ai-session-v1';
  var POLL_INTERVAL_MS = 1500;
  var MAX_POLL_ATTEMPTS = 180;

  function readSession() {
    try { return JSON.parse(sessionStorage.getItem(SESSION_KEY) || 'null'); } catch (error) { return null; }
  }

  function writeSession(value) {
    try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(value)); } catch (error) {}
  }

  function delay(milliseconds) {
    return new Promise(function (resolve) { window.setTimeout(resolve, milliseconds); });
  }

  function requestError(data, status) {
    var error = new Error(data.error || 'Something went wrong. Please try again.');
    error.code = data.code || 'request_failed';
    error.status = status;
    return error;
  }

  function createModal() {
    var modal = document.createElement('div');
    modal.className = 'dyefor-ai-remix-modal';
    modal.hidden = true;
    modal.innerHTML = '<div class="dyefor-ai-remix-dialog" role="dialog" aria-modal="true" aria-labelledby="DyeforAIRemixTitle">' +
      '<header class="dyefor-ai-remix-header"><h2 id="DyeforAIRemixTitle">Remix this design</h2><button class="dyefor-ai-remix-close" type="button" aria-label="Close">&times;</button></header>' +
      '<div class="dyefor-ai-remix-body">' +
        '<div class="dyefor-ai-remix-workspace" data-ai-remix-workspace>' +
          '<div class="dyefor-ai-remix-preview"><img data-ai-remix-source alt=""><div class="dyefor-ai-remix-loading" data-ai-remix-loading hidden><span class="dyefor-ai-remix-spinner" aria-hidden="true"></span><strong>Creating your remix</strong><p data-ai-remix-progress>Planning the new composition...</p></div></div>' +
          '<form class="dyefor-ai-remix-form" data-ai-remix-form novalidate>' +
            '<p>Keep what you love and change what you do not.</p>' +
            '<label class="dyefor-ai-remix-field"><span>Your changes</span><textarea name="prompt" minlength="8" maxlength="1200" rows="4" placeholder="Change the colours, wording, theme or mood" required></textarea></label>' +
            '<label class="dyefor-ai-remix-field"><span>Exact wording <small>optional</small></span><input type="text" name="exactText" maxlength="180" placeholder="Type the wording exactly as it should appear"></label>' +
            '<button class="dyefor-ai-remix-submit" type="submit"><span aria-hidden="true">&#10022;</span><strong data-ai-remix-submit-label>Create my remix</strong></button>' +
            '<p class="dyefor-ai-remix-message" data-ai-remix-message aria-live="polite"></p>' +
          '</form>' +
        '</div>' +
        '<div class="dyefor-ai-remix-result" data-ai-remix-result hidden><div class="dyefor-ai-remix-result-media"><img data-ai-remix-result-image alt="Your remixed personalised artwork" width="1024" height="1024"></div><div class="dyefor-ai-remix-result-actions"><button class="dyefor-ai-remix-secondary" type="button" data-ai-remix-again>Remix again</button><button class="dyefor-ai-remix-primary" type="button" data-ai-remix-use>Use this design</button></div></div>' +
      '</div>' +
    '</div>';
    document.body.appendChild(modal);
    return modal;
  }

  class ProductRemixController {
    constructor(buttons) {
      this.buttons = buttons;
      this.modal = createModal();
      this.dialog = this.modal.querySelector('.dyefor-ai-remix-dialog');
      this.title = this.modal.querySelector('#DyeforAIRemixTitle');
      this.workspace = this.modal.querySelector('[data-ai-remix-workspace]');
      this.sourceImage = this.modal.querySelector('[data-ai-remix-source]');
      this.loading = this.modal.querySelector('[data-ai-remix-loading]');
      this.progress = this.modal.querySelector('[data-ai-remix-progress]');
      this.form = this.modal.querySelector('[data-ai-remix-form]');
      this.prompt = this.form.elements.prompt;
      this.exactText = this.form.elements.exactText;
      this.submit = this.form.querySelector('.dyefor-ai-remix-submit');
      this.submitLabel = this.form.querySelector('[data-ai-remix-submit-label]');
      this.message = this.form.querySelector('[data-ai-remix-message]');
      this.result = this.modal.querySelector('[data-ai-remix-result]');
      this.resultImage = this.modal.querySelector('[data-ai-remix-result-image]');
      this.currentButton = null;
      this.currentResult = null;
      this.sourceDesignId = '';
      this.referenceUrl = '';
      this.pollVersion = 0;
      this.returnFocus = null;

      buttons.forEach(function (button) {
        button.addEventListener('click', function () { this.open(button); }.bind(this));
      }.bind(this));
      this.modal.querySelector('.dyefor-ai-remix-close').addEventListener('click', this.close.bind(this));
      this.modal.addEventListener('click', function (event) {
        if (event.target === this.modal) this.close();
      }.bind(this));
      this.form.addEventListener('submit', this.generate.bind(this));
      this.modal.querySelector('[data-ai-remix-again]').addEventListener('click', this.remixAgain.bind(this));
      this.modal.querySelector('[data-ai-remix-use]').addEventListener('click', this.useDesign.bind(this));
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !this.modal.hidden) this.close();
      }.bind(this));
    }

    open(button) {
      this.currentButton = button;
      this.returnFocus = button;
      this.referenceUrl = this.activeReferenceUrl(button);
      this.sourceDesignId = '';
      this.currentResult = null;
      this.title.textContent = 'Remix ' + button.dataset.productTitle;
      this.sourceImage.src = this.referenceUrl;
      this.sourceImage.alt = button.dataset.productTitle;
      this.prompt.value = '';
      this.exactText.value = '';
      this.showMessage('', false);
      this.setState('form');
      this.modal.hidden = false;
      document.documentElement.classList.add('dyefor-ai-remix-open');
      document.body.classList.add('dyefor-ai-remix-open');
      this.prompt.focus();
      this.track('remix_started', { productType: button.dataset.productType, productHandle: this.productHandle() });
    }

    close() {
      this.modal.hidden = true;
      document.documentElement.classList.remove('dyefor-ai-remix-open');
      document.body.classList.remove('dyefor-ai-remix-open');
      if (this.returnFocus) this.returnFocus.focus();
    }

    activeReferenceUrl(button) {
      var gallery = button.closest('slider-component');
      var active = gallery && (gallery.querySelector('.product__media-item.is-active img') || gallery.querySelector('.product__media-item:not([style*="display: none"]) img'));
      var source = active && (active.currentSrc || active.src) || button.dataset.referenceUrl;
      return new URL(source, window.location.href).href;
    }

    async ensureSession() {
      var stored = readSession();
      if (stored && stored.token && Number(stored.expiresAt) > Math.floor(Date.now() / 1000) + 60) return stored.token;
      var response = await fetch(API_BASE + '/v1/session', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ customerId: this.currentButton?.dataset.customerId || '' }),
        cache: 'no-store'
      });
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok || !data.token) throw requestError(data, response.status);
      writeSession(data);
      return data.token;
    }

    async request(path, options) {
      var token = await this.ensureSession();
      var settings = options || {};
      settings.headers = Object.assign({}, settings.headers || {}, { authorization: 'Bearer ' + token });
      settings.cache = 'no-store';
      var response = await fetch(API_BASE + path, settings);
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok) throw requestError(data, response.status);
      return data;
    }

    track(eventType, details) {
      this.request('/v1/event', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(Object.assign({ eventType: eventType }, details || {}))
      }).catch(function () {});
    }

    async generate(event) {
      event.preventDefault();
      var prompt = this.prompt.value.trim();
      if (prompt.length < 8) {
        this.showMessage('Add a little more detail to your changes.', true);
        this.prompt.focus();
        return;
      }
      var payload = {
        productType: this.currentButton.dataset.productType,
        mode: 'remix',
        prompt: prompt,
        exactText: this.exactText.value.trim()
      };
      if (payload.productType === 'phone_case') {
        payload.device = this.currentPhoneDevice();
        if (!payload.device) {
          this.showMessage('Choose an iPhone model on the product page first.', true);
          return;
        }
      }
      if (this.sourceDesignId) payload.sourceDesignId = this.sourceDesignId;
      else payload.referenceUrl = this.referenceUrl;

      this.pollVersion += 1;
      var version = this.pollVersion;
      this.setState('loading');
      this.showMessage('', false);
      this.updateProgress(0);
      try {
        var job = await this.request('/v1/generate', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(payload)
        });
        await this.poll(job, version);
      } catch (error) {
        if (version !== this.pollVersion) return;
        this.setState('form');
        this.showMessage(error.message, true);
      }
    }

    async poll(job, version) {
      for (var attempt = 0; attempt < MAX_POLL_ATTEMPTS; attempt += 1) {
        if (version !== this.pollVersion) return;
        if (attempt) await delay(POLL_INTERVAL_MS);
        this.updateProgress(attempt * POLL_INTERVAL_MS);
        var status;
        try {
          status = await this.request('/v1/designs/' + encodeURIComponent(job.designId));
        } catch (error) {
          if (attempt < 3 || error.status >= 500) continue;
          throw error;
        }
        if (status.status === 'failed') throw requestError(status, 400);
        if (status.status === 'succeeded') {
          this.currentResult = status;
          this.resultImage.src = (status.preview || status.asset).url;
          this.resultImage.alt = status.preview && status.preview.label || 'Your remixed personalised artwork';
          this.setState('result');
          this.track('result_viewed', this.resultDetails(status));
          return;
        }
      }
      throw new Error('This remix is taking longer than expected. Please try again in a moment.');
    }

    remixAgain() {
      if (!this.currentResult) return;
      this.sourceDesignId = this.currentResult.designId;
      this.sourceImage.src = this.currentResult.asset.url;
      this.prompt.value = '';
      this.exactText.value = '';
      this.showMessage('', false);
      this.setState('form');
      this.track('remix_started', this.resultDetails(this.currentResult));
      this.prompt.focus();
    }

    async useDesign() {
      if (!this.currentResult || !window.DyeforAIImageBridge) return;
      var details = this.resultDetails(this.currentResult);
      this.track('design_selected', details);
      try {
        await window.DyeforAIImageBridge.importImage(this.currentResult.asset, {
          designId: this.currentResult.designId,
          requestId: this.currentResult.requestId,
          assetId: this.currentResult.asset.id
        });
        this.close();
      } catch (error) {
        this.showMessage(error.message || 'The remix could not be opened in the personaliser.', true);
      }
    }

    setState(state) {
      var loading = state === 'loading';
      var result = state === 'result';
      this.workspace.hidden = result;
      this.result.hidden = !result;
      this.loading.hidden = !loading;
      Array.prototype.forEach.call(this.form.elements, function (element) { element.disabled = loading; });
      this.submitLabel.textContent = loading ? 'Creating...' : 'Create my remix';
    }

    updateProgress(elapsed) {
      var copy = 'Planning the new composition...';
      if (elapsed >= 18000) copy = 'Illustrating your changes...';
      if (elapsed >= 65000) copy = 'Refining colour and detail...';
      if (elapsed >= 125000) copy = 'Adding the finishing touches...';
      this.progress.textContent = copy;
    }

    showMessage(text, isError) {
      this.message.textContent = text || '';
      this.message.classList.toggle('is-error', Boolean(isError));
    }

    resultDetails(result) {
      return {
        designId: result.designId,
        requestId: result.requestId,
        productType: result.productType,
        productHandle: this.productHandle(),
        status: result.status,
        metadata: { device: this.currentPhoneDevice() || null }
      };
    }

    currentPhoneDevice() {
      if (!this.currentButton || this.currentButton.dataset.productType !== 'phone_case') return '';
      var select = document.querySelector('select[name="options[Phone Case]"]');
      if (select && select.value) return String(select.value).trim();
      var fromQuery = new URL(window.location.href).searchParams.get('device');
      if (fromQuery) return fromQuery.trim();
      try {
        var remembered = localStorage.getItem('dyefor:selected-device') || '';
        if (/^iphone\b/i.test(remembered)) return remembered.trim();
      } catch (error) {}
      return String(this.currentButton.dataset.productDevice || '').trim();
    }

    productHandle() {
      var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    }
  }

  var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-dyefor-ai-remix]'));
  if (buttons.length) new ProductRemixController(buttons);
})();
